export var ACTION;
(function (ACTION) {
    ACTION["GO_BACK"] = "GO_BACK";
    ACTION["RELEASE_COLLATERAL"] = "RELEASE_COLLATERAL";
    ACTION["NAVIGATE_TO_DASHBOARD"] = "NAVIGATE_TO_DASHBOARD";
    ACTION["CLOSE_ACCOUNT"] = "CLOSE_ACCOUNT";
    ACTION["CLEAR_DUES"] = "CLEAR_DUES";
    ACTION["STORE_FEEDBACK"] = "STORE_FEEDBACK";
})(ACTION || (ACTION = {}));
